/**
 * action to authorise the user [used internally]
 * tells the server/proxy who is calling
 */
export const WEBSOCKET_ACTION_AUTHORISE = 'authorise';

/**
 * action to welcome the user [used internally after handshake]
 * tells the client he is authorised and can communicate with us
 */
export const WEBSOCKET_ACTION_WELCOME = 'welcome';

/**
 * ping/pong isn't supported by browser websocket - so we've an action
 */
export const WEBSOCKET_ACTION_PING = 'ping';

/**
 * important layout-data-related changes
 */
export const WEBSOCKET_ACTION_REFETCH_LAYOUT_DATA = 'refetchLayoutData';

/**
 * a chat was created/edited
 */
export const WEBSOCKET_ACTION_CHAT_EDITED = 'chatEdited';

/**
 * the chat was deleted
 */
export const WEBSOCKET_ACTION_CHAT_DELETED = 'chatDeleted';

/**
 * there is a new chat message
 */
export const WEBSOCKET_ACTION_CHAT_NEW_MESSAGE = 'chatNewMessage';

/**
 * a participant from chat was added
 */
export const WEBSOCKET_ACTION_CHAT_ADD_PARTICIPANT = 'chatAddParticipant';

/**
 * a participant from chat was removed
 */
export const WEBSOCKET_ACTION_CHAT_REMOVE_PARTICIPANT = 'chatRemoveParticipant';

/**
 * the chat was read
 */
export const WEBSOCKET_ACTION_CHAT_READ = 'chatRead';

/**
 * an employee was created/edited (payload holds more data e.g. mail address or portrait)
 */
export const WEBSOCKET_ACTION_EMPLOYEE_EDITED = 'employeeEdited';

/**
 * refetch TelephoneList
 */
export const WEBSOCKET_ACTION_REFETCH_TELEPHONE = 'refetchTelephone';

/**
 * a calendar_entry was created/edited
 */
export const WEBSOCKET_ACTION_CALENDAR_ENTRY_EDITED = 'calendarEntryEdited';

/**
 * a calendar_entry was deleted
 */
export const WEBSOCKET_ACTION_CALENDAR_ENTRY_DELETED = 'calendarEntryDeleted';

/**
 * changes in Page Module
 */
export const WEBSOCKET_ACTION_PAGE_CHANGE = 'page-page';

/**
 * changes in Contact Module
 */
export const WEBSOCKET_ACTION_CONTACT_CHANGE = 'contact-contact';